/*global Modernizr, console, google */
/*jslint browser:true */

function mowgli_map_init() {
  'use strict';

  const map_init = new Event('mowgli-map');
  document.body.dispatchEvent(map_init);
}